import { SVGProps } from 'react';

export const IconCritical = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10.0003 18.3334C5.39795 18.3334 1.66699 14.6024 1.66699 10.0001C1.66699 5.39771 5.39795 1.66675 10.0003 1.66675C14.6027 1.66675 18.3337 5.39771 18.3337 10.0001C18.3337 14.6024 14.6027 18.3334 10.0003 18.3334ZM10.0003 8.82158L7.6433 6.46455L6.46479 7.64306L8.82183 10.0001L6.46479 12.3571L7.6433 13.5356L10.0003 11.1786L12.3573 13.5356L13.5358 12.3571L11.1788 10.0001L13.5358 7.64306L12.3573 6.46455L10.0003 8.82158Z'
        fill='currentColor'
      />
    </svg>
  );
};
